export const getLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

export const setLocalStorage = (key, data) => {
  return localStorage.setItem(key, JSON.stringify(data));
};

export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = (key) => {
  localStorage.clear();
};

export const getSessionStorage = (key) => {
  if (sessionStorage.getItem(key) !== "undefined")
    return JSON.parse(sessionStorage.getItem(key));
};

export const setSessionStorage = (key, data) => {
  return sessionStorage.setItem(key, JSON.stringify(data));
};

export const removeSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

export const clearSessionStorage = (key) => {
  sessionStorage.clear();
};
